import { Dispatch, FC, SetStateAction } from 'react';

import { StatusMeta } from './types';
import StatusOption, { StatusOptionProps } from './StatusOption';
import { INSIGHT_STATUS_DESCRIPTIONS } from '@silverfort-nodelibs/common/utils/consts';

interface Props {
    selectedStatus?: StatusMeta;
    setSelectedStatus: Dispatch<SetStateAction<StatusMeta | undefined>>;
}

const STATUS_OPTIONS: Omit<StatusOptionProps, 'isSelected' | 'onSelection'>[] = [
    {
        statusMeta: {
            status: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED,
            statusDescription: INSIGHT_STATUS_DESCRIPTIONS.FALSE_POSITIVE
        },
        title: 'False positive',
        description: 'Detection is inaccurate.'
    },
    {
        statusMeta: {
            status: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED,
            statusDescription: INSIGHT_STATUS_DESCRIPTIONS.PROTECTED
        },
        title: 'Compensating controls',
        description:
            'The exposure is still present but compensating controls (via Silverfort or other measures) are in place. You choose to suppress future alerts for this entity.'
    },
    {
        statusMeta: {
            status: INSIGHT_STATUS_DESCRIPTIONS.RESOLVED,
            statusDescription: INSIGHT_STATUS_DESCRIPTIONS.MITIGATED
        },
        title: 'Exposure resolved',
        description: `The exposure was mitigated via the IdP and will be counted as "Resolved". If the issue persists in the IdP, Silverfort will reopen the exposure.`
    }
];

const ResolutionFeedbackContent: FC<Props> = ({ selectedStatus, setSelectedStatus }) => {
    return (
        <div className="w-128 flex flex-col gap-4">
            <div className="font-sf text-12 text-sf-gray-800">
                Select the reason this exposure is resolved. This helps adjust the ISPM notifications according to your
                organization's needs.
            </div>
            {STATUS_OPTIONS.map((option) => (
                <StatusOption
                    key={option.title}
                    statusMeta={option.statusMeta}
                    isSelected={selectedStatus?.statusDescription === option.statusMeta.statusDescription}
                    onSelection={setSelectedStatus}
                    title={option.title}
                    description={option.description}
                />
            ))}
        </div>
    );
};

export default ResolutionFeedbackContent;
